var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU07 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 336.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-2197.00, 0.00)",
    id: "U7_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2204.36,218.88 C2205.90,211.36 2211.07,194.94 2214.26,187.47 C2217.46,180.02 2224.55,167.22 2229.88,159.21 C2234.40,152.65 2243.63,140.17 2248.34,134.25 C2253.11,128.54 2263.05,117.46 2268.90,111.89 C2275.02,106.17 2287.65,95.96 2294.16,91.45 C2301.25,86.56 2314.02,79.40 2320.74,76.67 C2327.47,73.96 2342.27,70.23 2348.41,70.01 C2356.52,69.76 2372.31,71.75 2380.43,74.05 C2386.21,75.70 2405.20,83.20 2411.25,86.06 C2417.28,88.92 2429.47,95.77 2436.37,101.26 C2442.03,105.80 2451.23,115.14 2455.36,120.55 C2459.51,126.02 2467.71,138.77 2473.55,148.67 C2477.04,154.74 2493.66,189.04 2500.47,203.53 C2504.07,211.52 2510.73,227.48 2513.69,235.36 C2516.40,243.16 2521.09,258.58 2523.06,266.18 C2525.12,274.84 2527.59,291.19 2528.24,299.73 C2528.86,308.27 2528.77,324.76 2528.05,333.17 C2527.25,341.01 2525.54,356.18 2524.55,363.18 C2523.49,369.84 2520.78,384.13 2518.32,391.67 C2515.35,400.67 2508.19,414.89 2504.02,419.90 C2501.81,422.51 2496.84,426.97 2494.07,428.82 C2490.88,430.92 2486.53,432.86 2482.98,433.89 C2477.53,435.43 2465.49,436.64 2458.30,436.38 C2442.34,435.91 2413.38,435.75 2388.82,435.42 C2353.79,435.50 2302.01,435.37 2287.07,434.88 C2280.28,434.52 2264.54,433.30 2259.06,432.16 C2253.33,430.95 2244.05,427.74 2240.80,425.83 C2236.65,423.35 2226.42,411.17 2223.85,406.52 C2222.08,403.26 2217.68,390.71 2216.16,384.56 C2212.33,368.96 2209.09,347.05 2206.19,321.41 C2204.40,305.21 2200.59,269.93 2200.82,254.56 C2201.09,238.27 2204.09,220.22 2204.36,218.88 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU07, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-07.a5cd9a63.svg";
export { ForwardRef as ReactComponent };